import useQuery from '@api/hooks/useQuery'
import { Skeleton, Stack, Typography } from '@mui/material'
import MarketBasketReportsApi, { MarketBasketReportsKeys } from '@services/marketBasketReports.api'
import { largeNumToString } from '@utils/stringHelpers'

export default function MonthlyTotalSavings() {
	const { data } = useQuery({
		queryKey: MarketBasketReportsKeys.monthlyTotalSavings,
		queryFn: MarketBasketReportsApi.monthlyTotalSavings,
	})
	return <MonthlyTotalSavingsUI title="Annual Total Savings" value={data} subtitle="this month" />
}

type UiProps = {
	title: string
	value: string | number
	subtitle?: string
}
export function MonthlyTotalSavingsUI({ title, value, subtitle = '' }: UiProps) {
	const displayValue = value != null ? largeNumToString(value) : null

	return (
		<Stack px="2rem" spacing={2} sx={{ width: '100%' }}>
			<Typography variant="body1" color="textSecondary">
				{title}
			</Typography>
			<Typography variant="h3">{displayValue || <Skeleton />}</Typography>
			<Typography variant="body2" color="text.secondary">
				{subtitle}
			</Typography>
		</Stack>
	)
}
